<template>
    <transition name="slide-fade">
        <div class="alert-point-modal" :class="{'open' : open}" v-if="open">
            <div class="modal-content">
                <div class="bg-white w-full content-wrapper p-3 relative ">
                    <div class="absolute right-6 top-3 cursor-pointer" @click="clickOk()">
                        <img class="w-4" src="../../../../assets/icon/ic-close.png" />
                    </div>
                    <div class="w-full text-center -mt-12">
                        <img class="w-20 m-auto" src="../../../../assets/icon/ic-success.png" />
                    </div>
                    <div class="text-center text-tc-blue-2 text-24 pt-3">{{lbl.register.title_point_modal}}</div>
                    <div v-if="type == 'point'">
                        <div class="flex items-center justify-center pt-3">
                            <div class="text-center text-20 text-tc-gray-3">{{lbl.register.you_get}}</div>
                            <span class="text-tc-blue-1 text-22 font-bold pl-2 pr-1">{{point}}</span>
                            <div> <img class="w-3" src="../../../../assets/icon/ic-coin.png" /> </div>
                        </div>
                        <div class="text-center text-20 text-tc-gray-3 pb-3 pt-2">
                            <span v-if="point <= 150">{{lbl.register.title2_point_modal}}</span>
                            <span v-else>{{lbl.register.title3_point_modal}}</span>
                        </div>
                    </div>
                    <div class="pt-2" v-else>
                        <div class="text-center text-20 text-tc-gray-3 pb-2.5" v-html="lbl.register.text_register_1"></div>
                        <div class="text-center text-20 text-tc-gray-3 pb-2.5">{{lbl.register.text_register_2}}</div>
                        <div class="w-full pb-4">
                            <img class="m-auto w-20 h-auto" src="@/assets/icon/ic-tip-society.png" />
                        </div>
                        <div class="w-full pb-5">
                            <div class="text-tc-blue-1 text-22 mt-5 bg-white border border-tc-blue-1 cursor-pointer
                                text-center m-auto p-2 mx-8 rounded-3xl" @click="clickGototip()">
                                {{lbl.register.goto_register_tip}}
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </transition>

    <transition name="fade">
        <div class="modal-backdrop" v-if="open"></div>
    </transition>
</template>
<script>
import Util from "@/helper/Utility.js";
import LocaleMixin from "@/mixin/LocaleMixin.js";

export default {
    name: "AlertPointModal",
    mixins: [LocaleMixin],
    props: {
        controller: Object,
    },
    data: function() {
        return {
            open: false,

            title: '',
            message: '',
            btnOk: '',
            busModal: null,
            point: 0,
            type: 'point',
        };
    },
    created: function() {
        this.busModal = this.controller.busModal;
    },
    mounted: function() {
        this.busModal.on('show', this.show);
        this.busModal.on('hide', this.hide);
    },
    methods: {
        show: function(config) {
            this.title = config.title;
            this.message = config.msg;
            this.btnOk = config.btnOk;
            this.point = config.point;
            this.type = config.type;

            if (Util.isEmptyStr(this.btnOk)) {
                this.btnOk = this.lbl.button.ok;
            }

            document.body.classList.add('not-scroll');
            this.open = true;
        },
        hide: function() {
            document.body.classList.remove('not-scroll');
            this.open = false;
        },
        clickOk: function () {
            this.hide();
            window.location.replace("/home");
            this.controller.sendCallbackOk();
        },
        clickGototip: function () {
            window.location.href = 'https://tipsociety.dhipaya.co.th/Accounts/Login'
        }
    },
}
</script>
<style lang="scss" scoped>
    @import "@/style/modal.scss";
    .modal {
        @extend %modal;
    }
</style>
<style lang="scss">
    @import "@/style/base/base.scss";
    @import "@/style/modal.scss";

    .alert-point-modal {
        @extend %modal;
        overflow: unset;

        @include mobile {
            top: auto;
        }
        .modal-content {
            width: 400px;
            overflow: unset;
            .content-wrapper {
                border-radius: 25px;
                @include mobile {
                    border-bottom-left-radius: 0px;
                    border-bottom-right-radius: 0px;

                    width: 100%;
                }
            }
            @include mobile {
                width: 100%;
            }
        }
    }
</style>
